
import entry from '@/http/requests/entry'

export default {
  fetchEntryList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      entry.list(data)
        .then(res => {
          if (data.page > 1) {
            commit('UPDATE_ENTRY_LIST', res.data.data)
          } else {
            commit('SET_ENTRY_LIST', res.data.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchEntryComments ({ commit }, id) {
    return new Promise((resolve, reject) => {
      entry.timeline(id)
        .then(res => {
          commit('SET_ENTRY_COMMENTS', res.data.data)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addEntryComment ({ commit }, data) {
    return new Promise((resolve, reject) => {
       entry.addComment(data)
        .then(response => {
          //console.log('add',res.data.item);
          commit('ADD_ENTRY_COMMENT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
